<div class="d-flex full-height">
    @if (ticketRightPanelService.isRightPanelOpened) {
        <div
            id="ticket-right-panel-content"
            class="right-panel-content"
            [ngClass]="{
                'p-0':
                    ticketRightPanelService.tabType === tabTypeEnum.notes ||
                    ticketRightPanelService.tabType === tabTypeEnum.log ||
                    ticketRightPanelService.tabType === tabTypeEnum.externalApp ||
                    ticketRightPanelService.tabType === tabTypeEnum.faq,
            }">
            @if (!isLoading) {
                <div class="container-element">
                    @switch (ticketRightPanelService.tabType) {
                        @case (tabTypeEnum.ticketAuthor) {
                            @if (isTabVisible(tabTypeEnum.ticketAuthor)) {
                                <app-user-info
                                    [isShowEditUserForm]="ticketRightPanelService.data.isShowEditUserForm"
                                    [user]="ticket.firstMessageCreator" />
                            }
                        }

                        @case (tabTypeEnum.notes) {
                            @if (isTabVisible(tabTypeEnum.notes)) {
                                <app-ticket-notes [ticket]="ticket" />
                            }
                        }

                        @case (tabTypeEnum.linkedTickets) {
                            @if (isTabVisible(tabTypeEnum.linkedTickets)) {
                                <app-linked-tickets [ticket]="ticket" />
                            }
                        }

                        @case (tabTypeEnum.log) {
                            @if (isTabVisible(tabTypeEnum.log)) {
                                <app-ticket-log [ticketId]="ticket.id" />
                            }
                        }

                        @case (tabTypeEnum.access) {
                            @if (isTabVisible(tabTypeEnum.access)) {
                                <app-ticket-access [ticket]="ticket" />
                            }
                        }

                        @case (tabTypeEnum.faq) {
                            @if (isTabVisible(tabTypeEnum.faq)) {
                                <iframe
                                    class="d-block w-100 h-100"
                                    [src]="faqIframeUrl"
                                    frameborder="0"
                                    allow="fullscreen"></iframe>
                            }
                        }

                        @case (tabTypeEnum.externalApp) {
                            @if (isTabVisible(tabTypeEnum.externalApp)) {
                                <app-application [ticket]="ticket" [currentApp]="currentApp" />
                            }
                        }

                        @case (tabTypeEnum.editFields) {
                            @if (isTabVisible(tabTypeEnum.editFields)) {
                                <app-edit-fields [ticket]="ticket" />
                            }
                        }
                    }
                </div>
            }
        </div>
    }
    <div class="right-panel-tabs-vertical">
        @if (isTabVisible(tabTypeEnum.ticketAuthor)) {
            <div
                class="right-panel-tab"
                data-testid="inbox-ui-right-sidebar-customer-profile"
                (click)="toggleTab(tabTypeEnum.ticketAuthor)"
                [ngClass]="{
                    active:
                        ticketRightPanelService.isRightPanelOpened &&
                        ticketRightPanelService.tabType === tabTypeEnum.ticketAuthor,
                }"
                [tooltip]="
                    ticketRightPanelService.isRightPanelOpened &&
                    ticketRightPanelService.tabType === tabTypeEnum.ticketAuthor
                        ? ''
                        : ('Customer profile' | translate)
                "
                placement="left"
                container="body">
                <div class="notification-badge-container">
                    <div class="notification-badge notification-badge-all" [hidden]="!ticket?.authorTicketCount">
                        {{ ticket?.authorTicketCount }}
                    </div>
                    <sb-inline-svg
                        class="icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Ticket author tab icon.svg'">
                    </sb-inline-svg>
                </div>
            </div>
        }
        @if (isTabVisible(tabTypeEnum.notes)) {
            <div
                class="right-panel-tab"
                data-testid="inbox-ui-right-sidebar-notes"
                (click)="toggleTab(tabTypeEnum.notes)"
                [ngClass]="{
                    active:
                        ticketRightPanelService.isRightPanelOpened &&
                        ticketRightPanelService.tabType === tabTypeEnum.notes,
                }"
                [tooltip]="
                    ticketRightPanelService.isRightPanelOpened && ticketRightPanelService.tabType === tabTypeEnum.notes
                        ? ''
                        : ('Notes' | translate)
                "
                placement="left"
                container="body">
                <div class="notification-badge-container">
                    @if (ticket?.noteCount) {
                        <div
                            class="notification-badge notification-badge-all"
                            [class.notification-badge-active]="ticket?.unreadNoteCount">
                            {{ ticket?.noteCount }}
                        </div>
                    }
                    <sb-inline-svg
                        class="icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Notes tab icon.svg'">
                    </sb-inline-svg>
                </div>
            </div>
        }
        @if (isTabVisible(tabTypeEnum.linkedTickets)) {
            <div
                class="right-panel-tab"
                data-testid="inbox-ui-right-sidebar-linked-tickets"
                (click)="toggleTab(tabTypeEnum.linkedTickets)"
                [ngClass]="{
                    active:
                        ticketRightPanelService.isRightPanelOpened &&
                        ticketRightPanelService.tabType === tabTypeEnum.linkedTickets,
                }"
                [tooltip]="
                    ticketRightPanelService.isRightPanelOpened &&
                    ticketRightPanelService.tabType === tabTypeEnum.linkedTickets
                        ? ''
                        : ('Linked tickets' | translate)
                "
                placement="left"
                container="body">
                <div class="notification-badge-container">
                    <div class="notification-badge notification-badge-all" [hidden]="!ticket?.linkedTicketCount">
                        {{ ticket?.linkedTicketCount }}
                    </div>
                    <sb-inline-svg
                        class="icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Linked tickets tab icon.svg'">
                    </sb-inline-svg>
                </div>
            </div>
        }
        @if (isTabVisible(tabTypeEnum.access)) {
            <div
                class="right-panel-tab"
                data-testid="inbox-ui-right-sidebar-access"
                (click)="toggleTab(tabTypeEnum.access)"
                [ngClass]="{
                    active:
                        ticketRightPanelService.isRightPanelOpened &&
                        ticketRightPanelService.tabType === tabTypeEnum.access,
                }"
                [tooltip]="
                    ticketRightPanelService.isRightPanelOpened && ticketRightPanelService.tabType === tabTypeEnum.access
                        ? ''
                        : ('Access' | translate)
                "
                placement="left"
                container="body">
                <sb-inline-svg
                    class="icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Access tab icon.svg'">
                </sb-inline-svg>
            </div>
        }
        @if (isTabVisible(tabTypeEnum.log)) {
            <div
                class="right-panel-tab"
                data-testid="inbox-ui-right-sidebar-log"
                (click)="toggleTab(tabTypeEnum.log)"
                [ngClass]="{
                    active:
                        ticketRightPanelService.isRightPanelOpened &&
                        ticketRightPanelService.tabType === tabTypeEnum.log,
                }"
                [tooltip]="
                    ticketRightPanelService.isRightPanelOpened && ticketRightPanelService.tabType === tabTypeEnum.log
                        ? ''
                        : ('Log' | translate)
                "
                placement="left"
                container="body">
                <sb-inline-svg class="icon" [url]="'/assets/images/activity-log.svg'" style="padding: 14px">
                </sb-inline-svg>
            </div>
        }
        @if (isTabVisible(tabTypeEnum.editFields)) {
            <div
                class="right-panel-tab"
                data-testid="inbox-ui-right-sidebar-edit-fields"
                (click)="toggleTab(tabTypeEnum.editFields)"
                [ngClass]="{
                    active:
                        ticketRightPanelService.isRightPanelOpened &&
                        ticketRightPanelService.tabType === tabTypeEnum.editFields,
                }"
                [tooltip]="
                    ticketRightPanelService.isRightPanelOpened &&
                    ticketRightPanelService.tabType === tabTypeEnum.editFields
                        ? ''
                        : ('Edit fields' | translate)
                "
                placement="left"
                container="body">
                <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/pencil-square.svg'"> </sb-inline-svg>
            </div>
        }

        @if (isTabVisible(tabTypeEnum.externalApp)) {
            @for (app of apps; track app) {
                @if (app.isActive) {
                    <div
                        class="right-panel-tab"
                        (click)="toggleTab(tabTypeEnum.externalApp, app)"
                        [ngClass]="{
                            active:
                                ticketRightPanelService.isRightPanelOpened &&
                                ticketRightPanelService.tabType === tabTypeEnum.externalApp &&
                                currentApp?.appId === app.appId,
                        }"
                        [tooltip]="
                            ticketRightPanelService.isRightPanelOpened &&
                            ticketRightPanelService.tabType === tabTypeEnum.externalApp &&
                            currentApp?.appId === app.appId
                                ? ''
                                : app.name
                        "
                        placement="left"
                        container="body">
                        <sb-inline-svg class="icon external-app" [url]="'/assets/images/dynamics-sales.svg'">
                        </sb-inline-svg>
                    </div>
                }
            }
        }

        <div class="bottom-block">
            @if (isTabVisible(tabTypeEnum.faq)) {
                <div
                    class="right-panel-tab d-flex justify-content-center align-items-center"
                    (click)="toggleTab(tabTypeEnum.faq)"
                    [ngClass]="{
                        active:
                            ticketRightPanelService.isRightPanelOpened &&
                            ticketRightPanelService.tabType === tabTypeEnum.faq,
                    }"
                    [tooltip]="
                        ticketRightPanelService.isRightPanelOpened &&
                        ticketRightPanelService.tabType === tabTypeEnum.faq
                            ? ''
                            : ('FAQ' | translate)
                    "
                    placement="left"
                    container="body">
                    <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/help-icon.svg'"> </sb-inline-svg>
                </div>
            }
        </div>
    </div>
</div>
